// Index.vue
<template>
  <router-view />
</template>

<script>
export default {
  name: "Index",
}
</script>